/**
 * The slot registrations of `web/views`: the catalogue toolbar's Views controls
 * (`catalogue.toolbar.views`, slot `catalogue.toolbar`, order 10). `apps/web/src/editor-services/
 * slots.ts` collects them as `SLOT_MODULES['web/views']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { ViewsToolbar } from './ViewsToolbar.js';

export const owner: WorkPackageId = '2.K';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'catalogue.toolbar', order: 10, owner: '2.K', component: ViewsToolbar },
];
